import React from 'react'
import { observer } from 'mobx-react-lite'
import { YStack } from '@mythical/ui'

import Section from 'app/components/structure/Section'
import { RedeemCollectable } from 'app/blocks/redeem-collectable'
import RichText from '../primitive/RichText'
import { useDidFinishSSR } from '@mythical/ui'
import Spinner from 'app/components/primitive/Spinner'

// Legacy Flexport-based redemption block.
// The backend embellisher now always returns isExpired=true.
// This component renders the expired/ineligible/redeemed text states only.

interface Props {
  block: RedeemCollectable
}

export const RedeemCollectableBlock: React.FC<Props> = observer(({ block }) => {
  const hasMounted = useDidFinishSSR()

  if (!hasMounted) {
    return (
      <Section ai="center" jc="center" bg="$bgPrimary">
        <Spinner size="large" />
      </Section>
    )
  }

  if (block.isExpired && block.expiredText) {
    return (
      <Section ai="flex-start" jc="flex-start" bg="$bgPrimary">
        <YStack>
          <RichText content={block.expiredText} />
        </YStack>
      </Section>
    )
  }

  if (block.hasRedeemed && block.redeemedText) {
    return (
      <Section ai="flex-start" jc="flex-start" bg="$bgPrimary">
        <YStack>
          <RichText content={block.redeemedText} />
        </YStack>
      </Section>
    )
  }

  if (block.ineligibleText) {
    return (
      <Section ai="flex-start" jc="flex-start" bg="$bgPrimary">
        <YStack>
          <RichText content={block.ineligibleText} />
        </YStack>
      </Section>
    )
  }

  return null
})
